import * as Style from './styles';

export const ListItemText = ({text, ...rest}) => {
    const {openSidebar} = rest;
    return(
        <Style.Span>
            {openSidebar && <span>{text}</span>}
        </Style.Span>
    )
}